import { forwardRef, type ForwardRefExoticComponent } from 'react';
import cx from 'classnames';

import { ChevronIcon } from 'src/components/ChevronIcon';
import { CustomButtonBase, type CustomButtonBaseProps } from 'src/components/CustomButtonBase';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

interface Props extends CustomButtonBaseProps {
  open?: boolean;
}

export const ButtonDropdown: ForwardRefExoticComponent<Props> = forwardRef(
  ({ className, open = false, children, ...restProps }, ref) => {
    const styles = useStyles();

    return (
      <CustomButtonBase
        className={cx(styles.root, className, {
          [styles.open]: open,
        })}
        ref={ref}
        {...restProps}
      >
        <div className={styles.children}>{children}</div>

        <ChevronIcon
          className={styles.chevronIcon}
          direction={open ? ROTATE_DIRECTION.up : ROTATE_DIRECTION.down}
        />
      </CustomButtonBase>
    );
  }
);
